// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpResmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpResmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpResmgrIconOutlined = function DrrpResmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpResmgrIconOutlinedSvg
  }));
};

DrrpResmgrIconOutlined.displayName = 'DrrpResmgrIconOutlined';
export default React.forwardRef(DrrpResmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpResmgrIconOutlined.js
// module id = 2578
// module chunks = 0